import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  footerRoot: {
    width: '100%',
    padding: '40px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#ffffff',
    zIndex: '10000',
    [theme.breakpoints.up('sm')]: {
      marginBottom: '0',
    },
  },
  typoRoot: {
    flex: '1',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logoImage: {
    width: '26px',
    [theme.breakpoints.up('sm')]: {
      width: '32px',
    },
  },
}));

const Footer = props => {
  const classes = useStyles();
  return (
    <footer className={classes.footerRoot} id="footer">
      <Typography variant="caption" className={classes.typoRoot}>
        <img
          src={require('../assets/images/ma-logo.svg')}
          className={classes.logoImage}
          alt="logo"
        />
        <span>
          © 2020 | Made with ❤️ by <strong>Mike Abolarin</strong>
        </span>
      </Typography>
    </footer>
  );
};

export default Footer;
